var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraAcc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1210_25947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.814 10L18.872 8.77867C18.6844 8.5372 18.4443 8.34161 18.1698 8.2067C17.8954 8.07179 17.5938 8.00111 17.288 8H14.712C14.4062 8.00111 14.1047 8.07179 13.8303 8.2067C13.5558 8.34161 13.3157 8.5372 13.128 8.77867L12.186 10H19.814Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 19.9998C17.4729 19.9998 18.6668 18.8059 18.6668 17.3332C18.6668 15.8604 17.4729 14.6665 16.0002 14.6665C14.5274 14.6665 13.3335 15.8604 13.3335 17.3332C13.3335 18.8059 14.5274 19.9998 16.0002 19.9998Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 11.3335H11.3333C10.4496 11.3346 9.60237 11.6861 8.97748 12.311C8.35259 12.9359 8.00106 13.7831 8 14.6668L8 20.6668C8.00106 21.5505 8.35259 22.3978 8.97748 23.0227C9.60237 23.6476 10.4496 23.9991 11.3333 24.0001H20.6667C21.5504 23.9991 22.3976 23.6476 23.0225 23.0227C23.6474 22.3978 23.9989 21.5505 24 20.6668V14.6668C23.9989 13.7831 23.6474 12.9359 23.0225 12.311C22.3976 11.6861 21.5504 11.3346 20.6667 11.3335ZM16 21.3335C15.2089 21.3335 14.4355 21.0989 13.7777 20.6594C13.1199 20.2198 12.6072 19.5951 12.3045 18.8642C12.0017 18.1333 11.9225 17.3291 12.0769 16.5531C12.2312 15.7772 12.6122 15.0645 13.1716 14.5051C13.731 13.9457 14.4437 13.5647 15.2196 13.4104C15.9956 13.256 16.7998 13.3352 17.5307 13.638C18.2616 13.9407 18.8864 14.4534 19.3259 15.1112C19.7654 15.769 20 16.5424 20 17.3335C19.9989 18.394 19.5772 19.4108 18.8273 20.1607C18.0773 20.9107 17.0605 21.3324 16 21.3335Z",
    fill: "#1F1F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1210_25947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraAcc);
export default __webpack_public_path__ + "static/media/Camera-acc.0f892cd1bcac348637adf7fe6fcfe631.svg";
export { ForwardRef as ReactComponent };